/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DasUBootGameAssets} from "../DasUBootGameAssets";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {MiniLampState} from "./parts/SpineLamp";
import {VignetteTint} from "../utils/DasUBootStatics";
import {DasUBootRoundType} from "../server/DasUBootData";
import {GraphicsPool} from "../utils/GraphicsPool";


export class DasUBootBackgroundElements extends PIXI.Container implements StageLayer {

    public backgroundView:PIXI.Container;
    public foregroundView:PIXI.Container;
    private _backgroundContainer:PIXI.Container;
    private _backgroundMain:PIXI.spine.Spine;
    private _backgroundFreespin:PIXI.spine.Spine;
    private _backgroundSuperFreespin:PIXI.spine.Spine;
    private vignette:PIXI.Sprite;
    private vignetteLight:PIXI.Sprite;
    private vignetteLoop:gsap.core.Timeline;
    private playingNearWin:boolean = false;
    private playingXBombAttention:boolean = false;
    private backgroundVignette:PIXI.NineSlicePlane;

    constructor() {
        super();
        this.name = "DasUBootBackgroundElements";
        this.init();
    }

    private init() {
        this.backgroundView = new PIXI.Container();
        this.foregroundView = new PIXI.Container();
        this._backgroundContainer = new PIXI.Container();

        // this._backgroundMain = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.MAIN_GAME_BACKGROUND)[0]);
        this._backgroundMain = GraphicsPool.spineFactory(DasUBootGameAssets.BG_SPINE);
        this._backgroundMain.state.setAnimation(0, "normal", true);
        this._backgroundMain.position.set(360, 360);
        //this._backgroundMain.anchor.set(0.5, 0.5);

        // this._backgroundFreespin = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.FREE_SPIN_BACKGROUND)[0]);
        this._backgroundFreespin = GraphicsPool.spineFactory(DasUBootGameAssets.BG_SPINE);
        this._backgroundFreespin.state.setAnimation(0, "freeSpins", true);
        this._backgroundFreespin.position.set(360, 360);
        //this._backgroundFreespin.anchor.set(0.5, 0.5);

        //  this._backgroundSuperFreespin = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.SUPER_FREE_SPIN_BACKGROUND)[0]);
        this._backgroundSuperFreespin = GraphicsPool.spineFactory(DasUBootGameAssets.BG_SPINE);
        this._backgroundSuperFreespin.state.setAnimation(0, "superFreeSpins", true);
        this._backgroundSuperFreespin.state.timeScale = 0.5;
        this._backgroundSuperFreespin.position.set(360, 360);
        //this._backgroundSuperFreespin.anchor.set(0.5, 0.5);

        this._backgroundContainer.addChild(this._backgroundMain);
        this._backgroundContainer.position.set(0, 0);

        this.backgroundVignette = new PIXI.NineSlicePlane(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.BACKGROUND_VIGNETTE)[0], 118,118,118,118);
        this.backgroundVignette.width = 1686;
        this.backgroundVignette.height = 1686;
        this.backgroundVignette.pivot.set(840,840);
        this.backgroundVignette.position.set(360,360);


        this.vignette = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.VIGNETTE)[0]);
        this.vignette.tint = 0x000000;
        this.vignette.anchor.set(0.5, 0.5);
        this.vignette.position.set(360, 360);
        this.vignette.alpha = 0.6;

        this.vignetteLight = new PIXI.Sprite(DasUBoot.assetLoader.getTextures(DasUBootGameAssets.VIGNETTE)[0]);
        this.vignetteLight.anchor.set(0.5, 0.5);
        this.vignetteLight.position.set(360, 360);
        this.vignetteLight.blendMode = PIXI.BLEND_MODES.ADD;
        this.vignetteLight.tint = 0xFF0000;
        this.vignetteLight.alpha = 0;
        this.vignetteLoop = this.createVignetteLightLoop();
        this.vignetteLoop.pause(0);

        this.backgroundView.addChild(this._backgroundContainer);
        this.backgroundView.addChild(this.backgroundVignette);
        this.addChild(this.backgroundView);

        this.foregroundView.addChild(this.vignette);
        this.foregroundView.addChild(this.vignetteLight);

        this.onOrientationChanged();
        this.onResize();

    }

    public onOrientationChanged() {

    }

    public onResize() {
        this.vignette.width = NolimitApplication.screenBounds.width;
        this.vignette.height = NolimitApplication.screenBounds.height;

        this.vignetteLight.width = NolimitApplication.screenBounds.width;
        this.vignetteLight.height = NolimitApplication.screenBounds.height;
    }

    private swapBackgroundTo(newBackground:PIXI.spine.Spine, duration:number):gsap.core.Timeline {

        const oldChildren:PIXI.DisplayObject[] = this._backgroundContainer.children.concat();

        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            newBackground.alpha = 0;
            this._backgroundContainer.addChild(newBackground);
        });

        tl.add(gsap.to(newBackground, {duration:duration, alpha:1}));

        tl.add(() => {
            while (oldChildren.length > 0) {
                const oldChild = oldChildren.pop()!;
                if (oldChild != newBackground) {
                    this._backgroundContainer.removeChild(oldChild);
                }
            }
        });


        return tl;
    }

    public setMode(mode:DasUBootRoundType, duration:number = 0.2):gsap.core.Timeline {
        if (mode == DasUBootRoundType.FREE_SPIN) {
            NolimitApplication.pixiApp.renderer.backgroundColor = PIXI.utils.string2hex('#120203');
            this.backgroundVignette.tint = PIXI.utils.string2hex('#120203');
            return this.swapBackgroundTo(this._backgroundFreespin, duration);
        } else if (mode == DasUBootRoundType.SUPER_FREE_SPIN) {
            NolimitApplication.pixiApp.renderer.backgroundColor = PIXI.utils.string2hex('#260a04');
            this.backgroundVignette.tint = PIXI.utils.string2hex('#260a04');
            return this.swapBackgroundTo(this._backgroundSuperFreespin, duration);
        } else {
            NolimitApplication.pixiApp.renderer.backgroundColor = PIXI.utils.string2hex('#06323f');
            this.backgroundVignette.tint = PIXI.utils.string2hex('#06323f');
            return this.swapBackgroundTo(this._backgroundMain, duration);
        }
    }

    private createVignetteLightLoop():gsap.core.Timeline {
        const tl = gsap.timeline({paused:true, repeat:-1, yoyo:true});
        tl.add(gsap.to(this.vignetteLight, {duration:0.333, alpha:0.6, ease:"Power2.easeInOut"}));
        return tl;
    }

    private playVignetteLoop(tint:number) {
        this.vignetteLight.tint = tint;
        this.vignetteLoop.play(0);
    }

    private stopVignetteLoop() {
        this.vignetteLoop.pause();
        gsap.to(this.vignetteLight, {duration:0.5, alpha:0});
    }

    public startXBombAttention() {
        if (this.playingXBombAttention) {
            return;
        }
        this.playingXBombAttention = true;
        this.playVignetteLoop(VignetteTint.RED);
        DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.RED, [0, 5]);
        DasUBoot.soundPlayer.startLampBlinkLoop();
    }

    public stopXBombAttention() {
        if (this.playingXBombAttention) {
            this.playingXBombAttention = false;
            this.stopVignetteLoop();
            DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.OFF, [0, 5]);
            DasUBoot.soundPlayer.stopLampBlinkLoop();
        }
    }

    public startNearWin(tint:number) {
        if (this.playingNearWin) {
            return;
        }
        this.playingNearWin = true;
        if (tint == VignetteTint.RED) {
            DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.RED, [0, 5]);
        } else if (VignetteTint.GREEN) {
            DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.GREEN, [0, 5]);
        } else {
            DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.YELLOW, [0, 5]);
        }

        this.playVignetteLoop(tint);

    }

    public stopNearWin(nextMode:string) {
        if (this.playingNearWin) {
            this.playingNearWin = false;
            this.stopVignetteLoop();
            DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.OFF, [0, 5]);

            if (this.playingXBombAttention) {
                this.playVignetteLoop(VignetteTint.RED);
                DasUBoot.reelView.reelFrame.switchMiniLamps(MiniLampState.RED, [0, 5]);
            }
        }

    }
}